import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";
import "./YoutubeCarousel.scss";

const YoutubeCarousel = ({ items }) => {
  const responsive = {
    all: {
      breakpoint: { max: 3000, min: 0 },
      items: 1,
      slidesToSlide: 1,
    },
  };

  return (
    <div id="youtubeCarousel">
      <Carousel
        //   swipeable={false}
        //   draggable={false}
        // showDots={true}
        responsive={responsive}
        //   infinite={true}
        keyBoardControl={true}
        containerClass="carousel-container"
        dotListClass="custom-dot-list-style"
        itemClass="carousel-item-padding-40-px"
        styles={{
          width: "100%",
        }}
      >
        {items.map((item) => {
          const { id } = item;
          const { videoId } = id;

          return (
            <iframe
              key={videoId}
              width="100%"
              height="650px"
              src={`https://www.youtube.com/embed/${videoId}`}
              title="YouTube video player"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
              allowFullScreen
            ></iframe>
          );
        })}
      </Carousel>
    </div>
  );
};

export default YoutubeCarousel;
